module.exports = __webpack_public_path__ + "static/media/map_pin_default.62638e5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/map_pin_default.svg
// module id = 604
// module chunks = 0